import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postAddCardForUser = async (cardAttributes) => {
  const apiPath = `cards/user/${cardAttributes.userId}/add-new-card`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: cardAttributes,
  });

  const response = await axios(signedRequest);

  return response.data;
};
